import _extends from "@babel/runtime/helpers/extends";
var apis = {
  topLevelList: function topLevelList(apiType) {
    var api = 'mtop.cainiao.geography.collaborate.countries.get';
    if (apiType == 'lazada') {
      api = 'mtop.cainiao.geography.lazada.common.division.country.list';
    }
    return api;
  },
  topLevelInfo: function topLevelInfo(apiType) {
    var api = 'mtop.cainiao.geography.collaborate.coountryByCountryCode.get';
    if (apiType == 'lazada') {
      api = 'mtop.cainiao.geography.lazada.common.division.countryid.get';
    }
    return api;
  },
  regionChain: function regionChain(apiType) {
    var api = 'mtop.cainiao.geography.collaborate.regionChain.get';
    if (apiType == 'lazada') {
      api = 'mtop.cainiao.geography.lazada.common.division.regionchain.query';
    }
    return api;
  },
  children: function children(apiType) {
    var api = 'mtop.cainiao.geography.collaborate.divisionsList.get';
    if (apiType == 'lazada') {
      api = 'mtop.cainiao.geography.lazada.common.division.children.get';
    }
    return api;
  },
  regionChainByName: function regionChainByName() {
    var api = 'mtop.cainiao.geography.collaborate.regionChainByName.get';
    return api;
  },
  // 解析查询接口
  regionChainByParse: function regionChainByParse() {
    var api = 'mtop.cainiao.geography.collaborate.regionChain.parse';
    return api;
  }
};
var MAX_REPEAT_ACTION_COUNT = 20;
function get(apiType, apiName, data, sendSDK) {
  if (data === void 0) {
    data = {};
  }
  var i = 0;
  var _data = data,
    countryCode = _data.countryCode,
    regionId = _data.regionId,
    divisionId = _data.divisionId,
    iso = _data.iso,
    applicationType = _data.applicationType,
    cnDataVersion = _data.cnDataVersion,
    id = _data.id,
    _data$maxLevel = _data.maxLevel,
    maxLevel = _data$maxLevel === void 0 ? 4 : _data$maxLevel,
    _data$businessId = _data.businessId,
    businessId = _data$businessId === void 0 ? '' : _data$businessId,
    _data$realm = _data.realm,
    realm = _data$realm === void 0 ? '' : _data$realm,
    divisionToken = _data.divisionToken,
    maxDataLevel = _data.maxDataLevel,
    divisionLevel = _data.divisionLevel,
    fullAddress = _data.fullAddress,
    isJsonpForMtop = _data.isJsonpForMtop,
    hideSensitiveDivision = _data.hideSensitiveDivision;
  var api = apis[apiName](apiType);
  iso = iso || countryCode;
  id = id || regionId || divisionId;
  return new Promise(function (resolve, reject) {
    action();
    function action() {
      i++;
      var requestBody = {
        api: api,
        v: '1.0',
        ecode: 0,
        dataType: isJsonpForMtop ? 'jsonp' : 'json',
        data: {
          applicationType: applicationType,
          cnDataVersion: cnDataVersion,
          countryCode: iso,
          regionId: id,
          divisionId: id,
          maxLevel: maxLevel,
          businessId: businessId,
          realm: realm,
          fullAddress: fullAddress,
          hideSensitiveDivision: hideSensitiveDivision
        }
      };
      if (divisionLevel) requestBody.data.divisionLevel = divisionLevel;
      if (apiName === 'regionChainByName') {
        requestBody.data = {
          divisionToken: divisionToken,
          applicationType: applicationType,
          cnDataVersion: cnDataVersion,
          businessId: businessId,
          realm: realm,
          maxDataLevel: maxDataLevel,
          iso: iso,
          hideSensitiveDivision: hideSensitiveDivision
        };
      }
      var _window = window,
        lib = _window.lib;
      var fetchPromise = undefined;
      if (sendSDK) {
        fetchPromise = sendSDK.sendMtop(requestBody);
      }
      if (!sendSDK && lib) {
        fetchPromise = lib.mtop.request(requestBody);
      }
      if (fetchPromise) {
        fetchPromise.then(function (res) {
          var _res$data;
          var resData = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data;
          // children处理敏感数据
          if (hideSensitiveDivision && apiType !== 'lazada') {
            if (apiName === 'children') {
              var newRes = resData === null || resData === void 0 ? void 0 : resData.divisions.filter(function (o) {
                return !o.sensitive;
              });
              resolve(_extends({}, resData, {
                divisions: newRes
              }));
            }
            if (apiName === 'topLevelList') {
              var _newRes = resData.filter(function (o) {
                return !o.sensitive;
              });
              resolve(_newRes || resData);
            }
            resolve(resData);
          } else {
            resolve(resData);
          }
        })["catch"](function (err) {
          console.error('CnAddress Error: mtop request failed', err);
          reject();
        });
      } else {
        if (i < MAX_REPEAT_ACTION_COUNT) {
          console.error('CnAddress Error: Try to find lib', i);
          setTimeout(action, 300);
        } else {
          console.error('CnAddress Error:  lib is not defined');
          reject();
        }
      }
    }
  });
}
export default {
  get: get,
  apis: apis
};